import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import CruiseLuxPlusLabel from 'components/Cruises/CruiseLuxPlusLabel'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import { getIsEnabledLuxPlusCruiseInclusions } from 'luxPlus/selectors/featureToggle'
import CruiseLuxPlusOnboardCreditLabel from 'components/Cruises/CruiseInclusion/CruiseLuxPlusOnboardCreditLabel'
import { useAppSelector } from 'hooks/reduxHooks'
import { buildAllStandardInclusions } from 'lib/cruises/cruiseInclusionsUtils'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  evergreenInclusions?: Array<App.EvergreenInclusion>
  tileInclusions?: Array<App.OfferInclusion>
  standardInclusions: Array<App.PackageInclusion>
  luxPlusInclusions: Array<App.PackageInclusion>
  canSeeLuxPlusLabel?: boolean
  offer?: App.CruiseOffer
}

function CruiseInclusionListHomeTile({
  standardInclusions,
  evergreenInclusions,
  tileInclusions,
  luxPlusInclusions,
  canSeeLuxPlusLabel,
  offer,
}: Props) {
  const intl = useIntl()
  const isEnabledLuxPlusCruiseInclusions = useAppSelector(getIsEnabledLuxPlusCruiseInclusions)

  const allStandardInclusions = useMemo(() => {
    return buildAllStandardInclusions(evergreenInclusions, standardInclusions, tileInclusions, false)
  }, [evergreenInclusions, standardInclusions, tileInclusions])

  const hasStandardInclusions = !!allStandardInclusions.length
  const hasLuxPlusInclusions = isEnabledLuxPlusCruiseInclusions && luxPlusInclusions.length > 0
  const hasInclusions = hasStandardInclusions || hasLuxPlusInclusions || canSeeLuxPlusLabel

  return <>
    {hasInclusions && <Group direction="vertical" gap={16} horizontalAlign="start">
      {(canSeeLuxPlusLabel || hasLuxPlusInclusions) && (
        <Group direction="vertical" gap={8} verticalAlign="center">
          {canSeeLuxPlusLabel && <CruiseLuxPlusLabel
            isModalEnabled
            offer={offer}
          />}

          {hasLuxPlusInclusions && (
            <CruiseLuxPlusOnboardCreditLabel
              luxPlusInclusions={luxPlusInclusions}
              offer={offer}
            />
          )}
        </Group>
      )}

      {hasStandardInclusions && (
        <VerticalSpacer gap={4}>
          {allStandardInclusions.map((inclusion) => <OfferInclusionItem
            key={inclusion.id}
            inclusion={inclusion}
            colour={inclusion.isHighlighted ? 'highlight-primary-dark' : undefined}
            showMinStayDescription
          />)}
          <BodyText variant="small" colour="normal-contrast">
            {intl.formatMessage({
              id: 'gWMOgND2ZhSab_HT-_aV',
              defaultMessage: 'Available on select packages',
              description: 'Note indicating inclusions are available on select cruise packages',
            })}
          </BodyText>
        </VerticalSpacer>
      )}
    </Group>}
  </>
}

export default CruiseInclusionListHomeTile
